import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=59f5ad52&"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestions.vue?vue&type=style&index=0&id=59f5ad52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports